import ToolPage from 'components/ToolPage';
import { toolAPI } from 'utils/api';

export default function MergePDF() {
  return (
    <ToolPage
      seoTitle="Merge PDF Online Free"
      seoDesc="Combine multiple PDF files into one document, free and fast. No signup, no watermark."
      path="/tools/pdf/merge"
      seoKey="merge-pdf"
      iconName="merge"
      title="Merge PDF"
      desc="Combine multiple PDF files into one document. Files are merged in the order you select them."
      accept=".pdf,application/pdf"
      multiple
      hint="Select 2 or more PDF files · Files merge in selection order · Max 50MB total"
      buttonLabel="Merge PDFs"
      apiCall={toolAPI.mergePDFs}
      outputFilename="merged.pdf"
      infoText="Select files in the exact order you want them merged. The first file selected becomes page 1."
    />
  );
}
